<template>
<div class="chapter">
<div class="inner_page">
<p class="ack">ACKNOWLEDGMENTS</p>
<p class="noindent">This book has been percolating in my mind for many years, and I’m excited to finally share it with you! Big shout-outs go to my editors and art directors at C&amp;T for helping me bring this book to life, and to my family for always supporting me. In addition, I want to send many, many thank-yous to all my sweet online friends and followers who give me endless inspiration and encouragement. Without you, I wouldn’t be able to do what I do. This book is for you.</p>
<p class="figure"><img alt="image" src="images/pg3_1.jpg"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 04_acknowledgments.vue?363067a4